import { render, staticRenderFns } from "./ModalAssinaturaDigital.vue?vue&type=template&id=2891fc1e&scoped=true"
import script from "./ModalAssinaturaDigital.vue?vue&type=script&lang=js"
export * from "./ModalAssinaturaDigital.vue?vue&type=script&lang=js"
import style0 from "./ModalAssinaturaDigital.vue?vue&type=style&index=0&id=2891fc1e&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2891fc1e",
  null
  
)

export default component.exports